import {Component, Input, OnInit} from '@angular/core';
import {ReservationDetail} from '../../../../../projects/shared-lib/src/lib/models/reservation-detail';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import { MatIcon } from '@angular/material/icon';
import { TwDatePipePipe } from '../../../shared/pipe/tw-date-pipe.pipe';

@Component({
    selector: 'tw-client-reservation-header',
    templateUrl: './client-reservation-header.component.html',
    styleUrls: ['./client-reservation-header.component.css'],
    imports: [MatIcon, TranslatePipe, TwDatePipePipe]
})
export class ClientReservationHeaderComponent implements OnInit {
    @Input() reservation: ReservationDetail;

    constructor(public translate: TranslateService) {
        registerLocaleData(localeFr, 'fr-FR', localeFrExtra);
    }

    ngOnInit() {}
}
